import React from "react";
import clsx from "clsx";
import { Dialog, DialogContent, Grid } from "@mui/material";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { ReadTextField } from "@icoach/components";

const CyclePurchasePaymentDialog = ({ className, open, sourceData = {}, onClose }) => {
	const { creditCardNo, cardExpiryDate, cardName, cardRelation, creditCardTypeText } = sourceData || {};

	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem" }} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>付款資訊</GradientColorHeader>
			<DialogContent>
				<Grid spacing={3} container>
					<Grid xs={12} item>
						<ReadTextField label={"信用卡號"}>{creditCardNo}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label={"有效期限"}>{cardExpiryDate}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label={"持卡人姓名"}>{cardName}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label={"持卡人關係"}>{cardRelation}</ReadTextField>
					</Grid>
					<Grid xs={12} item>
						<ReadTextField label={"卡別"}>{creditCardTypeText}</ReadTextField>
					</Grid>
				</Grid>
			</DialogContent>
		</Dialog>
	);
};

export default CyclePurchasePaymentDialog;
